import { render, staticRenderFns } from "./AllAppointments.vue?vue&type=template&id=e295de08&scoped=true"
import script from "./AllAppointments.vue?vue&type=script&lang=js"
export * from "./AllAppointments.vue?vue&type=script&lang=js"
import style0 from "./AllAppointments.vue?vue&type=style&index=0&id=e295de08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e295de08",
  null
  
)

export default component.exports